import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=98b75f06&scoped=true"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"
import style0 from "./scss/game.scss?vue&type=style&index=0&id=98b75f06&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b75f06",
  null
  
)

export default component.exports